/**
 * Created by Jie Gao on 2021-02-22.
 */
import {TimelineMax} from "gsap";
import {GGParsedGameData} from "../../server/data/GGParsedGameData";
import {BeforeSpinStopPresentationController} from "@nolimitcity/slot-game/bin/core/beforespinstoppresentation/BeforeSpinStopPresentationController";
import {RandomBuyIntroView} from "./RandomBuyIntroView";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";

export class RandomBuyIntroController extends BeforeSpinStopPresentationController {
    protected _view:RandomBuyIntroView;
    private _featureName:string;
    constructor(index:number) {
        super(index, "RandomBuyIntroController");
        this._view = new RandomBuyIntroView();
    }
    
    protected parseFeatureTriggered(data:GGParsedGameData):boolean {
        this._featureName = `Coming_out_${data.bombGuarantee ? "Explostive_" : ""}${(data.nextMode === "FREESPIN") ? "Fresh_Meat" : "Goblin_Fest"}`;
        return ((data.mode ===  GameMode.NORMAL)&&data.wasFeatureBuy && data.wasRandomBuy);
    }

    protected getSpinStopDelay(data:GGParsedGameData):number {
        return 3;
    }

    protected startPresentation(timeline:TimelineMax):void {
        this._view.show(timeline);
    }

    protected stopPresentation(isAborted:boolean):void {
        this._view.stopPresentation();
    }

    protected resetFeature() {}
}